"use client";

import React from "react";
import SharedContactForm from "@/components/Forms/SharedContactForm";
import { X } from "lucide-react";
import { createPortal } from "react-dom";

export default function RegisterModal({
  open,
  onClose,
  defaultProduct = "Căn hộ",
  apptOptions = [
    { label: "1PN", value: "1PN" },
    { label: "2PN", value: "2PN" },
    { label: "Studio", value: "Studio" },
  ],
  formTitle = "ĐĂNG KÝ TƯ VẤN NGAY",
  formSubtitle = "Nhận thông tin mặt bằng & bảng giá mới nhất",
  formLayoutTypeTitle = "Sản phẩm quan tâm",
}: {
  open: boolean;
  onClose: () => void;
  defaultProduct?: string;
  apptOptions?: { label: string; value: string }[];
  formTitle?: string;
  formSubtitle?: string;
  formLayoutTypeTitle?: string;
}) {

  if (!open || typeof window === "undefined") return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[1000] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[420px] bg-white border border-white/60 p-6 md:p-8 rounded-none shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] relative text-gray-800"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top decorative line */}
        <div className="absolute top-0 left-0 right-0 h-[4px] bg-[#B59A7A]"></div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
        >
          <X size={20} />
        </button>

        {/* Header */}
        <div className="text-center mb-6">
          <p className="text-[#B59A7A] text-[10px] font-bold uppercase tracking-[0.2em] mb-1.5">
            Thông tin đặc quyền
          </p>
          <h3 className="text-lg md:text-xl font-bold text-[#1a1a1a] uppercase tracking-wide">
            {formTitle}
          </h3>
          <p className="text-gray-500 text-[11px] mt-1 font-light italic">
            {formSubtitle}
          </p>
        </div>

        <SharedContactForm
          theme="light"
          defaultProduct={defaultProduct}
          apptOptions={apptOptions}
          submitButtonText="Đăng Ký Ngay"
          nguon={`Modal Đăng ký tư vấn: ${formTitle}`}
          onSuccess={onClose}
        />
      </div>
    </div>,
    document.body,
  );
}
